import styles from './oTab.module.scss';

interface ITab {
  tabs: string[];
  activeTab: string;
  onTabChange: (tab: string) => void;
  className?: string;
}

const OTab = ({ tabs, activeTab, onTabChange, className }: ITab) => {
  return (
    <div className={`${styles['otab-container']} ${className || ''}`}>
      {tabs.map((tab) => (
        <button
          key={tab}
          className={`${styles['otab-button']} ${activeTab === tab ? `${styles['active']}` : ''}`}
          onClick={() => onTabChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
};

export default OTab;
